import { IconButton } from "@mui/material";
import Logo from "../../../assets/logo.svg";
import "./styles/Footer.css";
import { ghostBlackStyles } from "../../../context/customStyles";
import { HomeRounded, ReplayRounded } from "@mui/icons-material";
const Footer = ({ onHomeClick, onRetryClick }) => {
  return (
    <footer id="report-footer">
      <IconButton
        style={ghostBlackStyles}
        color="black"
        className="icon-button"
        onClick={onHomeClick}
      >
        <HomeRounded fontSize="inherit" color="black" />
      </IconButton>
      <img src={Logo} alt="Assessive Logo" />
      <IconButton
        style={ghostBlackStyles}
        color="black"
        className="icon-button"
        onClick={onRetryClick}
      >
        <ReplayRounded fontSize="inherit" color="black" />
      </IconButton>
    </footer>
  );
};

export default Footer;
